<div class="factura-item" [ngClass]="{'factura-no-disponible': !esDescargable}">
  <div class="factura-content">
    <!-- Fecha -->
    <div class="factura-fecha">
      <span class="mes">{{ getMonth(factura.fecha) }}</span>
      <span class="anio">{{ getYear(factura.fecha) }}</span>
    </div>

    <!-- Monto -->
    <div class="factura-monto">
      <span class="monto-label">Monto</span>
      <span class="monto-valor">{{ formatearMonto(factura.importeTotal) }}</span>
    </div>

    <!-- Estado y Acción -->
    <div class="factura-accion">
      <div *ngIf="!esDescargable" class="estado-badge">
        <i class="fa fa-clock-o" aria-hidden="true"></i>
        <span>En Gestión de Cobranzas</span>
      </div>
      
      <button 
        *ngIf="esDescargable" 
        class="btn-descargar"
        (click)="onDescargarPDF()"
        [attr.aria-label]="'Descargar factura de ' + getMonth(factura.fecha) + ' ' + getYear(factura.fecha)"
        type="button">
        <i class="fa fa-download" aria-hidden="true"></i>
        <span class="btn-text">Descargar PDF</span>
      </button>
    </div>
  </div>
</div>